export default "__VITE_ASSET__9b52a92f__"